import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './banklog.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const BanklogDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const banklogEntity = useAppSelector(state => state.banklog.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="banklogDetailsHeading">
          <Translate contentKey="comexApp.banklog.detail.title">Banklog</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{banklogEntity.id}</dd>
          <dt>
            <span id="login">
              <Translate contentKey="comexApp.banklog.login">Login</Translate>
            </span>
          </dt>
          <dd>{banklogEntity.login}</dd>
          <dt>
            <span id="request">
              <Translate contentKey="comexApp.banklog.request">Request</Translate>
            </span>
          </dt>
          <dd>{banklogEntity.request}</dd>
          <dt>
            <span id="response">
              <Translate contentKey="comexApp.banklog.response">Response</Translate>
            </span>
          </dt>
          <dd>{banklogEntity.response}</dd>
        </dl>
        <Button tag={Link} to="/banklog" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/banklog/${banklogEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BanklogDetail;
